<div class="settingsContainer">
  @if (spinner) {
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
    <span class="sr-only">Loading...</span>
  }
  <div class="header hdr">
    <h5><span class="animateH5">Settings</span></h5>
  </div>
  <div class="container-fluid align-items-start configContents">
    <div class="row">
      <div class="col-md-2 offset-md-1 configTab2">
        <ul class="nav flex-column nav-pills nav-justified" id="v-pills-tab">
          <li
            class="nav-item jerk-tab-class"
            [ngClass]="{ tri: tabTriangle === 'profile' }"
            (click)="showTriangle('profile')"
            (keydown.enter)="showTriangle('profile')"
            (click)="getProfileData()"
            (keydown.enter)="getProfileData()"
          >
            <a
              class="nav-link"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
              [ngClass]="{ active: tabTriangle === 'profile' }"
              >Profile</a
            >
          </li>
          <li
            class="nav-item jerk-tab-class"
            [ngClass]="{ tri: tabTriangle === 'passwordReset' }"
            (click)="showTriangle('passwordReset')"
            (keydown.enter)="showTriangle('passwordReset')"
          >
            <a
              class="nav-link"
              id="password-reset-tab"
              [ngClass]="{ active: tabTriangle === 'passwordReset' }"
              type="button"
              aria-selected="false"
              >Change Password</a
            >
          </li>
          <li
            class="nav-item jerk-tab-class"
            [ngClass]="{ tri: tabTriangle === 'authentication' }"
            (click)="showTriangle('authentication')"
            (keydown.enter)="showTriangle('authentication')"
            (click)="getAuthenticationData()"
            (keydown.enter)="getAuthenticationData()"
          >
            <a
              class="nav-link"
              id="authentication-tab"
              data-bs-toggle="tab"
              data-bs-target="#authentication"
              type="button"
              role="tab"
              aria-controls="authentication"
              aria-selected="false"
              [ngClass]="{ active: tabTriangle === 'authentication' }"
              >Authentication
            </a>
          </li>
          <li
            class="nav-item jerk-tab-class"
            [ngClass]="{ tri: tabTriangle === 'companyLogo' }"
            (click)="showTriangle('companyLogo')"
            (keydown.enter)="showTriangle('companyLogo')"
            (click)="getCompanyLogoData()"
            (keydown.enter)="getCompanyLogoData()"
          >
            @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
              <a
                class="nav-link"
                id="company-logo-tab"
                data-bs-toggle="tab"
                data-bs-target="#company-logo"
                type="button"
                role="tab"
                aria-controls="company-logo"
                aria-selected="false"
                [ngClass]="{ active: tabTriangle === 'companyLogo' }"
                >Company Logo</a
              >
            }
          </li>
          @if (
            userDetails?.role_id === 1 ||
            userDetails?.role_id === 2 ||
            userDetails?.role_id === 0
          ) {
            <li
              class="nav-item jerk-tab-class"
              [ngClass]="{
                tri: tabTriangle === 'usage',
                active: tabTriangle === 'usage',
              }"
              (click)="showTriangle('usage')"
              (keydown.enter)="showTriangle('usage')"
              (click)="getUsageData()"
              (keydown.enter)="getUsageData()"
              #usageTab
            >
              <a
                class="nav-link"
                id="usage-tab"
                type="button"
                aria-selected="false"
                [ngClass]="{ active: tabTriangle === 'usage' }"
                >Usage</a
              >
            </li>
          }
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="nav-item jerk-tab-class"
              [ngClass]="{ tri: tabTriangle === 'subscription' }"
              (click)="showTriangle('subscription')"
              (keydown.enter)="showTriangle('subscription')"
              (click)="upgradePlans('subcriptionDetails')"
              (keydown.enter)="upgradePlans('subcriptionDetails')"
              (click)="getActivePlanDetails()"
              (keydown.enter)="getActivePlanDetails()"
            >
              <a
                class="nav-link active tabBtn"
                id="Subscritption-tab"
                data-bs-toggle="tab"
                data-bs-target="#Subscritption"
                type="button"
                role="tab"
                aria-controls="Subscritption"
                aria-selected="true"
                [ngClass]="{ active: tabTriangle === 'subscription' }"
                >Subscription</a
              >
            </li>
          }
          @if (userDetails?.role_id === 1 || userDetails?.role_id === 0) {
            <li
              class="nav-item jerk-tab-class"
              [ngClass]="{ tri: tabTriangle === 'purchase' }"
              (click)="showTriangle('purchase')"
              (keydown.enter)="showTriangle('purchase')"
              (click)="getPurchaseData()"
              (keydown.enter)="getPurchaseData()"
            >
              <a
                class="nav-link"
                id="purchase-history-tab"
                data-bs-toggle="tab"
                data-bs-target="#purchase-history"
                type="button"
                role="tab"
                aria-controls="purchase-history"
                aria-selected="false"
                [ngClass]="{ active: tabTriangle === 'purchase' }"
                >Purchase History</a
              >
            </li>
          }
        </ul>
      </div>
      <div class="col-md-9 tableTab2">
        <div class="tab-content" id="v-pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="Subscritption"
            role="tabpanel"
          >
            @if (
              showPlans === "subcriptionDetails" &&
              !spinner &&
              tabTriangle === "subscription"
            ) {
              <div class="col-md-7">
                <div class="card settingsCard">
                  <ul class="list-group">
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-md-5 subscription-plan-heading">
                          <p><b>Current Plan</b></p>
                        </div>
                        <div class="col-md-6 subscription-plan-heading">
                          <p class="plan-details">{{ planName }}</p>
                          @if (false) {
                            <a
                              class="plan-details-2"
                              (click)="upgradePlans('planDetails')"
                              (keydown.enter)="upgradePlans('planDetails')"
                              ><small>Upgrade plan</small></a
                            >
                          }
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-md-5 subscription-plan-heading">
                          <p><b>Status</b></p>
                        </div>
                        <div class="col-md-6 subscription-plan-heading">
                          <span
                            class="badge"
                            [ngClass]="{
                              'bg-success': activePlanData.status === 'ACTIVE',
                              'bg-danger':
                                activePlanData.status === 'TERMINATED',
                              'bg-secondary':
                                activePlanData.status !== 'ACTIVE' &&
                                activePlanData.status !== 'TERMINATED',
                            }"
                            >{{ activePlanData.status }}</span
                          >
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-md-5 subscription-plan-heading">
                          <p><b>User Count</b></p>
                        </div>
                        <div class="col-md-6 subscription-plan-heading">
                          <p class="plan-details">
                            {{ activePlanData.purchased_user_count }}
                          </p>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-md-5 subscription-plan-heading">
                          <p><b>Start Date</b></p>
                        </div>
                        <div class="col-md-6 subscription-plan-heading">
                          <p class="plan-details">
                            {{ activePlanData.start_date }}
                          </p>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-md-5 subscription-plan-heading">
                          <p><b>Expiry Date</b></p>
                        </div>
                        <div class="col-md-6 subscription-plan-heading">
                          <p class="plan-details">
                            {{ activePlanData.expiry_date }}
                          </p>
                        </div>
                      </div>
                    </li>
                    @if (activePlanData.grace_period_end) {
                      <li class="list-group-item">
                        <div class="row">
                          <div class="col-md-5 subscription-plan-heading">
                            <p><b>Grace Period Ends</b></p>
                          </div>
                          <div class="col-md-6 subscription-plan-heading">
                            <p class="plan-details">
                              {{ activePlanData.grace_period_end }}
                            </p>
                          </div>
                        </div>
                      </li>
                    }
                    <li class="list-group-item">
                      <div class="row">
                        <div class="col-md-5 subscription-plan-heading">
                          <p><b>Amount Paid</b></p>
                        </div>
                        <div class="col-md-6 subscription-plan-heading">
                          <p class="plan-details">
                            ${{ activePlanData.amount_paid | number: "1.2-2" }}
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            }
            @if (showPlans === "planDetails") {
              <div class="container-fluid subscription-second-part">
                <div class="row">
                  <div class="col-md-4">
                    <div class="card settingsCard animateH5 jerk-class">
                      <h3 class="text-center plan-name">Business</h3>
                      <div class="rate">
                        <h1 class="plan-cost text-center">
                          <small class="cost-simbol">$</small>59
                        </h1>
                        <p class="text-center plan-details">Per Month / User</p>
                        <p class="text-center plan-details">
                          $708 Billed Annually
                        </p>
                        @if (planName === "Business") {
                          <button
                            class="btn btn-primary"
                            [ngClass]="{
                              currentPlanBtn: planName === 'Business',
                              updateBtn: planName !== 'Business',
                            }"
                            (click)="upgradePlans('subscrptionform')"
                            (keydown.enter)="upgradePlans('subscrptionform')"
                            (click)="currentPlan('current', 'Business', 2)"
                            (keydown.enter)="
                              currentPlan('current', 'Business', 2)
                            "
                          >
                            <span>Current Plan</span>
                          </button>
                        }
                        @if (planName !== "Business") {
                          <button
                            class="btn btn-primary"
                            [ngClass]="{
                              currentPlanBtn: planName === 'Business',
                              updateBtn: planName !== 'Business',
                            }"
                            (click)="upgradePlans('subscrptionform')"
                            (keydown.enter)="upgradePlans('subscrptionform')"
                            (click)="currentPlan('buy', 'Business', 2)"
                            (keydown.enter)="currentPlan('buy', 'Business', 2)"
                          >
                            <span>Buy</span>
                          </button>
                        }
                      </div>
                      <div class="feature">
                        <p><b>Available on Cloud</b></p>
                        <p><b>Number of file: 50</b></p>
                        <p><b>File Size: Up to 25 MB</b></p>
                        <p>Audio Transcript</p>
                        <p>Text Translation & Analytics</p>
                        <p>Sentiment Analysis</p>
                        <p>Information Extraction</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="card settingsCard animateH5 jerk-class">
                      <h3 class="text-center plan-name">Business Plus</h3>
                      <div class="rate">
                        <h1 class="plan-cost text-center">
                          <small class="cost-simbol">$</small>99
                        </h1>
                        <p class="text-center plan-details">Per Month / User</p>
                        <p class="text-center plan-details">
                          $1188 Billed Annually
                        </p>
                        @if (planName === "Business Plus") {
                          <button
                            class="btn btn-primary"
                            [ngClass]="{
                              currentPlanBtn: planName === 'Business Plus',
                              updateBtn: planName !== 'Business Plus',
                            }"
                            (click)="upgradePlans('subscrptionform')"
                            (keydown.enter)="upgradePlans('subscrptionform')"
                            (click)="currentPlan('current', 'Business Plus', 3)"
                            (keydown.enter)="
                              currentPlan('current', 'Business Plus', 3)
                            "
                          >
                            <span>Current Plan</span>
                          </button>
                        }
                        @if (planName !== "Business Plus") {
                          <button
                            class="btn btn-primary"
                            [ngClass]="{
                              currentPlanBtn: planName === 'Business Plus',
                              updateBtn: planName !== 'Business Plus',
                            }"
                            (click)="upgradePlans('subscrptionform')"
                            (keydown.enter)="upgradePlans('subscrptionform')"
                            (click)="currentPlan('buy', 'Business Plus', 3)"
                            (keydown.enter)="
                              currentPlan('buy', 'Business Plus', 3)
                            "
                          >
                            <span>Buy</span>
                          </button>
                        }
                      </div>
                      <div class="feature">
                        <p><b>Available on Cloud</b></p>
                        <p><b>Number of file: 100</b></p>
                        <p><b>File Size: Up to 50 MB</b></p>
                        <p>Audio Transcript</p>
                        <p>Text Translation & Analytics</p>
                        <p>Sentiment Analysis</p>
                        <p>Information Extraction</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div
                      class="card settingsCard enterprisesCard animateH5 jerk-class"
                    >
                      <h3 class="text-center plan-name">Enterprise</h3>
                      <div class="rate">
                        <p class="text-center plan-details">
                          Contact Us For Flexible Enterprise Plan
                        </p>
                        <br />
                        <br />
                        <br />
                        <br />
                        <a
                          href="https://ca.canstring.ai/analyzer-EP-price-request"
                          target="_blank"
                          ><button class="btn btn-success">
                            Contact Us
                          </button></a
                        >
                      </div>
                      <div class="feature">
                        <p><b>Cloud, On-Premises, Hybrid</b></p>
                        <p><b>Number of file: Unlimited</b></p>
                        <p><b>File Size: Up to 225 MB</b></p>
                        <p>Audio Transcript</p>
                        <p>Text Translation & Analytics</p>
                        <p>Sentiment Analysis</p>
                        <p>Information Extraction</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (showPlans === "subscrptionform") {
              <div class="container-fluid subscription-third-part">
                @if (!showSuccessSubscription) {
                  <div class="row">
                    <div class="col-md-6 subscription-form-column1">
                      <div class="card settingsCard">
                        <div class="card-header">
                          <div class="main-heading">
                            <div class="first">
                              <b>Payment Details</b>
                            </div>
                            <div class="second">
                              <small>Powered by <b>stripe</b></small>
                            </div>
                          </div>
                        </div>
                        <div class="card-body">
                          <form
                            [formGroup]="subscriptionForm"
                            autocomplete="off"
                          >
                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for="cardName"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted &&
                                        fsubscription['card_name'].errors,
                                    }"
                                    class="form-label mandatoryLabel"
                                    >Name of the Card
                                    <i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="card_name"
                                    id="card_name"
                                    formControlName="card_name"
                                    placeholder="Enter card name"
                                  />
                                  @if (
                                    submitted &&
                                    fsubscription["card_name"].errors
                                  ) {
                                    <div class="invalid-feedback">
                                      @if (
                                        fsubscription["card_name"].errors[
                                          "required"
                                        ] && fsubscription["card_name"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Card name is required
                                        </div>
                                      }
                                      @if (
                                        fsubscription["card_name"].errors[
                                          "pattern"
                                        ] && fsubscription["card_name"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Enter valid Card name
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for=""
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted && !stripeCardValid,
                                    }"
                                    class="form-label mandatoryLabel"
                                    >Credit Card<i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <ngx-stripe-card
                                    [options]="cardOptions"
                                    [elementsOptions]="elementsOptions"
                                    (change)="onChange($event)"
                                  ></ngx-stripe-card>
                                  @if (submitted) {
                                    <div class="invalid-feedback">
                                      @if (
                                        submitted &&
                                        !stripeCardValid &&
                                        subscriptionForm.dirty &&
                                        subscriptionForm.invalid
                                      ) {
                                        <div class="text-danger">
                                          Card number is required
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for=""
                                    class="form-label mandatoryLabel"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted &&
                                        fsubscription['userscount'].errors,
                                    }"
                                    >Number Of User<i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <input
                                    class="form-control"
                                    name="userscount"
                                    id="userscount"
                                    placeholder=""
                                    type="number"
                                    min="1"
                                    [(ngModel)]="userCountEntry"
                                    [ngModelOptions]="{ standalone: true }"
                                    (keyup)="userCountFun(userCountEntry)"
                                    (change)="userCountFun(userCountEntry)"
                                    onkeydown="return event.keyCode !== 69;"
                                  />
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for=""
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted &&
                                        fsubscription['company_name'].errors,
                                    }"
                                    class="form-label mandatoryLabel"
                                    >Company Name
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="company_name"
                                    id="company_name"
                                    formControlName="company_name"
                                    placeholder=""
                                  />
                                  @if (
                                    submitted &&
                                    fsubscription["company_name"].errors
                                  ) {
                                    <div class="invalid-feedback">
                                      @if (
                                        fsubscription["company_name"].errors[
                                          "required"
                                        ] &&
                                        fsubscription["company_name"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Company name is required
                                        </div>
                                      }
                                      @if (
                                        fsubscription["company_name"].errors[
                                          "pattern"
                                        ] &&
                                        fsubscription["company_name"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Enter valid company name
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for=""
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted &&
                                        fsubscription['address1'].errors,
                                    }"
                                    class="form-label mandatoryLabel"
                                    >Billing Address
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="address1"
                                    id="address1"
                                    formControlName="address1"
                                    placeholder=""
                                  />
                                  @if (
                                    submitted &&
                                    fsubscription["address1"].errors
                                  ) {
                                    <div class="invalid-feedback">
                                      @if (
                                        fsubscription["address1"].errors[
                                          "required"
                                        ] && fsubscription["address1"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Address is required
                                        </div>
                                      }
                                      @if (
                                        fsubscription["address1"].errors[
                                          "pattern"
                                        ] && fsubscription["address1"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Enter valid input data
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for="address2"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted &&
                                        fsubscription['address2'].errors,
                                    }"
                                    class="form-label mandatoryLabel"
                                    >Billing Address 2
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="address2"
                                    id="address2"
                                    formControlName="address2"
                                    placeholder=""
                                  />
                                  @if (
                                    submitted &&
                                    fsubscription["address2"].errors
                                  ) {
                                    <div class="invalid-feedback">
                                      @if (
                                        fsubscription["address2"].errors[
                                          "required"
                                        ] && fsubscription["address2"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Address is required
                                        </div>
                                      }
                                      @if (
                                        fsubscription["address2"].errors[
                                          "pattern"
                                        ] && fsubscription["address2"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Enter valid input data
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label
                                    for=""
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted &&
                                        fsubscription['city'].errors,
                                    }"
                                    class="form-label mandatoryLabel"
                                    >City
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="city"
                                    id="city"
                                    formControlName="city"
                                    placeholder=""
                                  />
                                  @if (
                                    submitted && fsubscription["city"].errors
                                  ) {
                                    <div class="invalid-feedback">
                                      @if (
                                        fsubscription["city"].errors[
                                          "required"
                                        ] && fsubscription["city"].invalid
                                      ) {
                                        <div class="text-danger">
                                          City is required
                                        </div>
                                      }
                                      @if (
                                        fsubscription["city"].errors[
                                          "pattern"
                                        ] && fsubscription["city"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Enter valid input data
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label
                                    for=""
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted &&
                                        fsubscription['state'].errors,
                                    }"
                                    class="form-label mandatoryLabel"
                                    >State
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="state"
                                    id="state"
                                    formControlName="state"
                                    placeholder=""
                                  />
                                  @if (
                                    submitted && fsubscription["state"].errors
                                  ) {
                                    <div class="invalid-feedback">
                                      @if (
                                        fsubscription["state"].errors[
                                          "required"
                                        ] && fsubscription["state"].invalid
                                      ) {
                                        <div class="text-danger">
                                          State is required
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label
                                    for=""
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted &&
                                        fsubscription['country'].errors,
                                    }"
                                    class="form-label mandatoryLabel"
                                    >Country
                                  </label>
                                  <ng-select
                                    (change)="chooseCountry($event)"
                                    formGroupName="country"
                                    name="country"
                                    id="country"
                                    placeholder="Choose/Search country"
                                  >
                                    @for (
                                      country of country_list;
                                      track country
                                    ) {
                                      <ng-option [value]="country">{{
                                        country
                                      }}</ng-option>
                                    }
                                  </ng-select>
                                  @if (
                                    submitted && fsubscription["country"].errors
                                  ) {
                                    <div class="invalid-feedback">
                                      @if (
                                        fsubscription["country"].errors[
                                          "required"
                                        ] && fsubscription["country"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Country is required
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-10 offset-md-1 btn-section">
                                <button
                                  class="btn btn-primary updateBtn"
                                  (click)="createToken()"
                                  (keydown.enter)="createToken()"
                                  [disabled]="spinner2"
                                >
                                  @if (spinner2) {
                                    <i
                                      class="fa fa-spinner fa-pulse fa-3x fa-fw"
                                    ></i>
                                  }
                                  <span class="sr-only">Loading...</span> Pay
                                </button>
                                <p class="privacy-policy">
                                  By clicking the "Pay" button above, you are
                                  agreeing to our <a>Terms of Service</a> And
                                  <a>Privacy Policy</a>
                                </p>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 subscription-form-column2">
                      <div class="card settingsCard summaryCard">
                        <div class="card-header summaryCardHeader">
                          <p class="first">Order Summary</p>
                          <p class="second">
                            <a
                              (click)="upgradePlans('subcriptionDetails')"
                              (keydown.enter)="
                                upgradePlans('subcriptionDetails')
                              "
                              >Change Plan</a
                            >
                          </p>
                        </div>
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-6">
                              <p>Plan</p>
                            </div>
                            <div class="col-md-6">
                              <p>{{ buyPlan }}</p>
                            </div>
                            <div class="col-md-6">
                              <p>User Count</p>
                            </div>
                            <div class="col-md-6">
                              <p>{{ userCountEntry }}</p>
                            </div>
                            <div class="col-md-6">
                              <p>Contract term</p>
                            </div>
                            <div class="col-md-6">
                              <p>12 months</p>
                            </div>
                            <div
                              class="col-md-6"
                              [ngClass]="{
                                'border-bottom': currentPlanData === 'current',
                              }"
                            >
                              <p>Billing cycle</p>
                            </div>
                            <div
                              class="col-md-6"
                              [ngClass]="{
                                'border-bottom': currentPlanData === 'current',
                              }"
                            >
                              <p>Annually</p>
                            </div>
                            @if (currentPlanData === "buy") {
                              <div class="col-md-6 border-bottom">
                                <p>Balance</p>
                              </div>
                            }
                            @if (currentPlanData === "buy") {
                              <div class="col-md-6 border-bottom">
                                <p>
                                  ${{
                                    $safeNavigationMigration(
                                      activePlanData?.balance_amount
                                    ) | number: "1.0-0"
                                  }}
                                </p>
                              </div>
                            }
                            <div class="col-md-6">
                              <p class="total-class">Total</p>
                            </div>
                            <div class="col-md-6">
                              @if (buyPlan === "Business Plus") {
                                <p class="total-class">
                                  ${{ userCountEntry * 99 * 12 }}
                                  <small>($99/month)</small>
                                </p>
                              }
                              @if (buyPlan === "Business") {
                                <p class="total-class">
                                  ${{ userCountEntry * 59 * 12 }}
                                  <small>($59/month)</small>
                                </p>
                              }
                            </div>
                            @if (currentPlanData === "buy") {
                              <div class="col-md-6">
                                <p>Total Pay</p>
                              </div>
                            }
                            @if (currentPlanData === "buy") {
                              <div class="col-md-6">
                                @if (buyPlan === "Business Plus") {
                                  <p class="total-class">
                                    @if (
                                      userCountEntry * 99 * 12 >
                                      activePlanData?.balance_amount
                                    ) {
                                      <span
                                        >${{
                                          userCountEntry * 99 * 12 -
                                            $safeNavigationMigration(
                                              activePlanData?.balance_amount
                                            ) | number: "1.0-0"
                                        }}</span
                                      >
                                    }
                                    @if (
                                      userCountEntry * 99 * 12 <
                                      activePlanData?.balance_amount
                                    ) {
                                      <span>$0</span>
                                    }
                                    <small>($99/month)</small>
                                  </p>
                                }
                                @if (buyPlan === "Business") {
                                  <p class="total-class">
                                    @if (
                                      userCountEntry * 59 * 12 >
                                      activePlanData?.balance_amount
                                    ) {
                                      <span
                                        >${{
                                          userCountEntry * 59 * 12 -
                                            $safeNavigationMigration(
                                              activePlanData?.balance_amount
                                            ) | number: "1.0-0"
                                        }}</span
                                      >
                                    }
                                    @if (
                                      userCountEntry * 59 * 12 <
                                      activePlanData?.balance_amount
                                    ) {
                                      <span>$0</span>
                                    }
                                    <small>($59/month)</small>
                                  </p>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (showSuccessSubscription) {
                  <div class="container subscription-success-container">
                    <div class="col-md-10">
                      <div class="row">
                        <div class="card settingsCard">
                          <div class="col-md-12 text-center">
                            <h2>
                              Thanks for your subscription with CanString AI!
                            </h2>
                            <p>
                              You have successfully made a payment with
                              CanString AI.
                            </p>
                            <p>We will sent a receipt to your email address.</p>
                          </div>
                          <div class="col-md-12 text-center">
                            <button
                              class="btn btn-primary updateBtn"
                              (click)="subscriptionSubmit()"
                              (keydown.enter)="subscriptionSubmit()"
                              [disabled]="spinner2"
                            >
                              @if (spinner2) {
                                <i
                                  class="fa fa-spinner fa-pulse fa-3x fa-fw"
                                ></i>
                              }
                              <span class="sr-only">Loading...</span> Confirm
                              Subscription
                            </button>
                            <button
                              class="btn btn-primary cancelBtn"
                              (click)="goBackSubscriptionFormSection()"
                              (keydown.enter)="goBackSubscriptionFormSection()"
                            >
                              Go Back
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <div class="tab-pane fade" id="purchase-history" role="tabpanel">
            @if (tabTriangle === "purchase") {
              <div class="container-fluid purchase-container">
                <div class="table-responsive">
                  <div class="card settingsCard">
                    <table class="table">
                      <thead class="tblHead">
                        <tr>
                          <th>Date</th>
                          <th>Order #</th>
                          <th>Description</th>
                          <th>Service Period</th>
                          <th>Payment Method</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        @if (purchaseData.length === 0) {
                          <tr>
                            <td
                              colspan="6"
                              style="
                                width: 100%;
                                text-align: center;
                                display: inline-block;
                                color: #666;
                              "
                            >
                              No records found.
                            </td>
                          </tr>
                        }
                        @for (
                          purchase of purchaseData;
                          track purchase;
                          let i = $index
                        ) {
                          <tr>
                            <td>{{ purchase.date }}</td>
                            <td>{{ purchase.order_number }}</td>
                            <td>{{ purchase.description }}</td>
                            <td>{{ purchase.service_period }}</td>
                            <td>{{ purchase.payment_method }}</td>
                            <td>${{ purchase.total | number: "1.2-2" }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="usage-class" id="usage">
            @if (tabTriangle === "usage") {
              <div class="container-fluid usageContainer">
                <div class="row">
                  <!-- Row 1: Documents + Knowledge Base + Companies -->
                  <div class="row g-3 mb-3">
                    <div class="col-md-5">
                      <div class="card settingsCard usageStat">
                        <p class="stat-label">
                          <i class="fa-regular fa-file-lines usageIcon-sm"></i>
                          Total Documents
                        </p>
                        <p class="stat-value">{{ usageData.total_created }}</p>
                        <div class="stat-sub">
                          <span class="chip chip-docx">
                            <i class="fa-regular fa-file-word"></i> DOCX:
                            {{ usageData.total_created_docx }}
                          </span>
                          <span class="chip chip-excel">
                            <i class="fa-regular fa-file-excel"></i> Excel:
                            {{ usageData.total_created_excel }}
                          </span>
                          <span class="chip chip-pdf">
                            <i class="fa-regular fa-file-pdf"></i> PDF:
                            {{ usageData.total_created_pdf }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="card settingsCard usageStat">
                        <p class="stat-label">
                          <i class="fa-solid fa-database usageIcon-sm"></i>
                          Knowledge Base Entries
                        </p>
                        <p class="stat-value">{{ usageData.total_kb }}</p>
                        <div class="stat-sub">
                          <span class="chip chip-docx">
                            <i class="fa-regular fa-file-word"></i> DOCX:
                            {{ usageData.total_kb_docx }}
                          </span>
                          <span class="chip chip-excel">
                            <i class="fa-regular fa-file-excel"></i> Excel:
                            {{ usageData.total_kb_excel }}
                          </span>
                          <span class="chip chip-pdf">
                            <i class="fa-regular fa-file-pdf"></i> PDF:
                            {{ usageData.total_kb_pdf }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="card settingsCard usageStat">
                        <p class="stat-label">
                          <i class="fa-regular fa-building usageIcon-sm"></i>
                          Companies
                        </p>
                        <p class="stat-value">
                          {{ usageData.total_companies }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- Row 2: Users + Relationships -->
                  <div class="row g-3">
                    <div class="col-md-3">
                      <div class="card settingsCard usageStat">
                        <p class="stat-label">
                          <i class="fa-regular fa-user usageIcon-sm"></i> Users
                        </p>
                        <p class="stat-value">
                          {{ usageData.total_users_by_app }}
                        </p>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="card settingsCard usageStat">
                        <p class="stat-label">
                          <i class="fa-solid fa-link usageIcon-sm"></i>
                          Relationships
                        </p>
                        <p class="stat-value">
                          {{ usageData.total_company_relationship }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="" id="password-reset">
            @if (tabTriangle === "passwordReset") {
              <div class="container-fluid passwordRestContainer">
                <div class="col-md-6">
                  <div class="col-md-12">
                    <div class="card settingsCard">
                      <div class="card-header">
                        <b>Change Password</b>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <form [formGroup]="passwordForm" autocomplete="off">
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for="currentPassword"
                                    class="form-label mandatoryLabel"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted &&
                                        f['currentPassword'].errors,
                                    }"
                                    >Current Password<i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <input
                                    type="password"
                                    class="form-control"
                                    formControlName="currentPassword"
                                    name="currentPassword"
                                    id="currentPassword"
                                    (input)="
                                      removePasswordSpaces(
                                        $event,
                                        'currentPassword'
                                      )
                                    "
                                    placeholder=""
                                  />
                                  @if (
                                    submitted && f["currentPassword"].errors
                                  ) {
                                    <div class="invalid-feedback">
                                      @if (
                                        f["currentPassword"].errors[
                                          "required"
                                        ] && f["currentPassword"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Current Password is required
                                        </div>
                                      }
                                      @if (
                                        f["currentPassword"].errors["pattern"]
                                      ) {
                                        <div class="text-danger">
                                          Password must be at least 8 characters
                                          long and contain at least one
                                          uppercase letter, one lowercase
                                          letter, one number, and one special
                                          character (e.g $, &#64;, !, #,
                                          &).
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for="newPassword"
                                    class="form-label mandatoryLabel"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted && f['newPassword'].errors,
                                    }"
                                    >New Password
                                    <i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <div class="input-field new-pass-input-field">
                                    <input
                                      [type]="type"
                                      class="form-control"
                                      formControlName="newPassword"
                                      name="newPassword"
                                      id="newPassword"
                                      placeholder=""
                                      (input)="
                                        removePasswordSpaces(
                                          $event,
                                          'newPassword'
                                        )
                                      "
                                    />
                                    <span
                                      class="fa {{ eyeIcon }} passwordEye"
                                      (click)="hideShowPassword()"
                                      (keydown.enter)="hideShowPassword()"
                                    ></span>
                                  </div>
                                  @if (submitted && f["newPassword"].errors) {
                                    <div class="invalid-feedback">
                                      @if (
                                        f["newPassword"].errors["required"] &&
                                        f["newPassword"].invalid
                                      ) {
                                        <div class="text-danger">
                                          New password is required
                                        </div>
                                      }
                                      @if (f["newPassword"].errors["pattern"]) {
                                        <div class="text-danger">
                                          Password must be at least 8 characters
                                          long and contain at least one
                                          uppercase letter, one lowercase
                                          letter, one number, and one special
                                          character (e.g $, &#64;, !, #,
                                          &).
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for=""
                                    class="form-label mandatoryLabel"
                                    >Confirm Password
                                    <i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <input
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted &&
                                        f['confirmPassword'].errors &&
                                        f['confirmPassword'].invalid,
                                    }"
                                    type="password"
                                    class="form-control"
                                    formControlName="confirmPassword"
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    placeholder=""
                                  />
                                  @if (
                                    submitted &&
                                    f["confirmPassword"].errors &&
                                    f["confirmPassword"].invalid
                                  ) {
                                    <div
                                      class="text-danger"
                                      class="invalid-feedback"
                                    >
                                      @if (
                                        f["confirmPassword"].errors[
                                          "required"
                                        ] && f["confirmPassword"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Confirm password is required
                                        </div>
                                      }
                                      @if (
                                        f["confirmPassword"].errors["matching"]
                                      ) {
                                        <div class="text-danger">
                                          Confirm Password doesn't match. Please
                                          re-enter your password.
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-10 offset-md-1 btnColumn">
                                <button
                                  class="btn btn-primary updateBtn"
                                  (click)="updatePassword()"
                                  (keydown.enter)="updatePassword()"
                                >
                                  Update
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="tab-pane fade" id="company-logo" role="tabpanel">
            @if (tabTriangle === "companyLogo") {
              <div class="container-fluid passwordRestContainer">
                <div class="col-md-7">
                  <div class="col-md-12">
                    <div class="card settingsCard">
                      <div class="card-header">
                        <b>Company Logo Upload</b>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <form
                              [formGroup]="companyLogoForm"
                              autocomplete="off"
                            >
                              <div
                                class="col-md-12 text-center profile-pic-wrapper"
                              >
                                <div
                                  class="file-tab cursor-pointer"
                                  (click)="fileUpload2.click()"
                                  (keydown.enter)="fileUpload2.click()"
                                >
                                  @if (showCompanyLogo) {
                                    <img
                                      class="company-logo-picture-class"
                                      [src]="companyLogoImageSrc"
                                      alt="your"
                                      id="logo-image"
                                    />
                                  }
                                  @if (!showCompanyLogo) {
                                    <i
                                      class="fa-solid fa-upload file-upload"
                                    ></i>
                                  }
                                  <input
                                    (change)="
                                      onFileChange(
                                        $event,
                                        ['jpg', 'jpeg', 'png'],
                                        'companyLogo'
                                      )
                                    "
                                    type="file"
                                    #fileUpload2
                                    class="form-control"
                                    accept="image/*"
                                    name="logo"
                                    id="logo"
                                    formControlName="logo"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted && fCompany['logo'].errors,
                                    }"
                                  />
                                  @if (submitted && fCompany["logo"].errors) {
                                    <div class="invalid-feedback">
                                      @if (
                                        fCompany["logo"].errors["required"] &&
                                        fCompany["logo"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Logo is required
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                                @if (showCompanyLogo) {
                                  <i
                                    (keydown.enter)="fileUpload2.click()"
                                    (keydown.space)="fileUpload2.click()"
                                    class="fa-solid fa-camera cameraIcon"
                                    (click)="fileUpload2.click()"
                                    (keydown.enter)="fileUpload2.click()"
                                  ></i>
                                }
                                <!-- delete icon removed -->
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for=""
                                    class="form-label mandatoryLabel"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted && fCompany['title'].errors,
                                    }"
                                    >Title<i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="title"
                                    id="title"
                                    formControlName="title"
                                    placeholder=""
                                  />
                                  @if (submitted && fCompany["title"].errors) {
                                    <div class="invalid-feedback">
                                      @if (
                                        fCompany["title"].errors["required"] &&
                                        fCompany["title"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Titile is required
                                        </div>
                                      }
                                      @if (
                                        companyLogoForm
                                          .get("title")
                                          ?.hasError("pattern")
                                      ) {
                                        <div class="text-danger">
                                          Enter valid title
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for=""
                                    class="form-label mandatoryLabel"
                                    [ngClass]="{
                                      'is-invalid':
                                        submitted && fCompany['caption'].errors,
                                    }"
                                    >Caption
                                    <i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="caption"
                                    id="caption"
                                    formControlName="caption"
                                    placeholder=""
                                  />
                                  @if (
                                    submitted && fCompany["caption"].errors
                                  ) {
                                    <div class="invalid-feedback">
                                      @if (
                                        fCompany["caption"].errors[
                                          "required"
                                        ] && fCompany["caption"].invalid
                                      ) {
                                        <div class="text-danger">
                                          Caption is required
                                        </div>
                                      }
                                      @if (
                                        companyLogoForm
                                          .get("caption")
                                          ?.hasError("pattern")
                                      ) {
                                        <div class="text-danger">
                                          Enter valid caption
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-10 offset-md-1 btnColumn">
                                <button
                                  class="btn btn-primary updateBtn"
                                  (click)="updateCompanyLogo()"
                                  (keydown.enter)="updateCompanyLogo()"
                                  [disabled]="
                                    fCompany['title'].invalid ||
                                    fCompany['caption'].invalid
                                  "
                                >
                                  Update
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="tab-pane fade" id="profile" role="tabpanel">
            @if (tabTriangle === "profile") {
              <div class="container-fluid passwordRestContainer">
                <div class="col-md-7">
                  <div class="col-md-12">
                    <div class="card settingsCard">
                      <div class="card-header">
                        <b>Profile</b>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <form [formGroup]="profileForm" autocomplete="off">
                              <div
                                class="col-md-12 text-center profile-pic-wrapper"
                              >
                                <div
                                  class="file-tab cursor-pointer"
                                  (click)="fileUpload.click()"
                                  (keydown.enter)="fileUpload.click()"
                                >
                                  @if (showPrfilePic) {
                                    <img
                                      id="profile-picture"
                                      class="profile-picture-class"
                                      [src]="imageSrc"
                                      alt=""
                                    />
                                  }
                                  @if (!showPrfilePic) {
                                    <i
                                      class="fa-solid fa-upload file-upload"
                                    ></i>
                                  }
                                  <input
                                    (change)="
                                      onFileChange(
                                        $event,
                                        ['jpg', 'png', 'jpeg'],
                                        'profile'
                                      )
                                    "
                                    type="file"
                                    #fileUpload
                                    class="form-control"
                                    accept="image/*"
                                  />
                                </div>
                                @if (showPrfilePic) {
                                  <i
                                    class="fa-solid fa-camera cameraIcon"
                                    (click)="fileUpload.click()"
                                    (keydown.enter)="fileUpload.click()"
                                  ></i>
                                }
                                <!-- delete icon removed -->
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for=""
                                    class="form-label mandatoryLabel"
                                    >User Name<i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    name="name"
                                    id="name"
                                    formControlName="name"
                                    placeholder=""
                                  />
                                  @if (
                                    submitted &&
                                    profileForm
                                      .get("name")
                                      ?.hasError("required")
                                  ) {
                                    <div class="text-danger">
                                      User name is required
                                    </div>
                                  }
                                  @if (
                                    submitted &&
                                    profileForm.get("name")?.hasError("pattern")
                                  ) {
                                    <div class="text-danger">
                                      Enter valid user name
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for=""
                                    class="form-label mandatoryLabel"
                                    >Email
                                    <i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <input
                                    type="email"
                                    class="form-control"
                                    name="email"
                                    id="email"
                                    formControlName="email"
                                    placeholder=""
                                  />
                                </div>
                              </div>
                              <div class="col-md-12">
                                <div class="form-group">
                                  <label
                                    for=""
                                    class="form-label mandatoryLabel"
                                    >Phone Number
                                    <i
                                      class="fa-solid fa-asterisk mandatoryIcon"
                                    ></i
                                  ></label>
                                  <app-phone-number-input
                                    formControlName="phone"
                                    [isInvalid]="phoneInvalid"
                                    [parentErrors]="phoneErrors"
                                    defaultCountry="US"
                                  >
                                  </app-phone-number-input>
                                </div>
                              </div>
                              <div class="col-md-10 offset-md-1 btnColumn">
                                <button
                                  class="btn btn-primary updateBtn"
                                  type="button"
                                  (click)="updateProfileData()"
                                  (keydown.enter)="updateProfileData()"
                                  [disabled]="profileForm.invalid"
                                >
                                  Update
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="tab-pane fade" id="authentication" role="tabpanel">
            @if (tabTriangle === "authentication") {
              <div class="container-fluid passwordRestContainer">
                <div class="col-md-7">
                  <div class="col-md-12">
                    <div class="card settingsCard">
                      <div class="card-header">
                        <b>Authentication</b>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <form>
                              <div class="col-md-12">
                                <!--  radio group -->
                                <div class="auth-mode-group">
                                  @for (mode of authModes; track mode) {
                                    <label
                                      class="auth-radio-label"
                                      [class.active]="
                                        selectedAuthMode === mode.value
                                      "
                                    >
                                      <input
                                        type="radio"
                                        name="authMode"
                                        [value]="mode.value"
                                        [(ngModel)]="selectedAuthMode"
                                        (change)="onAuthModeChange(mode.value)"
                                      />
                                      {{ mode.label }}
                                    </label>
                                  }
                                </div>
                                <!-- OTP channel selector - only for PASSWORD_OTP or OTP_ONLY -->
                                <!-- OTP channel selector -->
                                @if (
                                  selectedAuthMode === "PASSWORD_OTP" ||
                                  selectedAuthMode === "OTP_ONLY"
                                ) {
                                  <div class="otp-channel-section">
                                    <p class="otp-channel-label">
                                      Send OTP via
                                    </p>
                                    <div class="otp-channels">
                                      <label
                                        class="channel-box"
                                        [class.checked]="chooseEmail"
                                      >
                                        <input
                                          type="checkbox"
                                          [checked]="chooseEmail"
                                          (change)="chooseEmailFun('email')"
                                        />
                                        <i
                                          class="fa-regular fa-envelope channel-icon"
                                        ></i>
                                        <span>Email</span>
                                      </label>
                                      <label
                                        class="channel-box"
                                        [class.checked]="choosePhone"
                                      >
                                        <input
                                          type="checkbox"
                                          [checked]="choosePhone"
                                          (change)="choosePhoneFun('phone')"
                                        />
                                        <i
                                          class="fa-solid fa-mobile-screen channel-icon"
                                        ></i>
                                        <span>Mobile</span>
                                      </label>
                                    </div>
                                  </div>
                                }
                                <!-- Update button- full width, inside the card -->
                                <div class="auth-update-row">
                                  <button
                                    class="btn btn-primary updateBtn auth-update-btn"
                                    (click)="updateAuthentication()"
                                    (keydown.enter)="updateAuthentication()"
                                    [disabled]="!authenticationEvent"
                                  >
                                    Save changes
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- delete modal for Delete profile picture-->
<div
  class="modal fade deleteModal"
  id="deleteProfilPicModal"
  tabindex="-1"
  aria-labelledby="deleteProfilPicModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="deleteProfilPicModalLabel">Delete File</h4>
        <i
          class="fa-solid fa-xmark exitIcon"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></i>
      </div>
      <div class="modal-body">Are you sure, you want to delete?</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          No
        </button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="removeProfilepic()"
          (keydown.enter)="removeProfilepic()"
          data-bs-dismiss="modal"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
